
import {
    GET_EMAIL_AGENTS,
    SAVE_EMAIL_AGENTS,
    GET_EMAIL_GROUPS,
    SAVE_EMAIL_GROUPS,
    SAVE_EMAIL_ASSIGNMENT_RULES,
    GET_ALL_EMAIL_ASSIGNMENT_RULES,
    SEND_EMAIL_ASSIGNMENT_RULES,
    UPDATE_EMAIL_ASSIGNMENT_RULES,
    SAVE_ALL_EMAIL_ASSIGNMENT_RULES,
    DELETE_EMAIL_ASSIGNMENT_RULE,
    UPDATE_EMAIL_ASSIGNMENT_RULE_STATUS,
    RESET_EMAIL_ASSIGNMENT,
  } from "../constants/EmailAssignment";
  
  export const geteEmailAgents = () => {
    return {
      type: GET_EMAIL_AGENTS,
    };
  };
  
  export const resetEmailAssignment = () => {
    return {
      type: RESET_EMAIL_ASSIGNMENT
    };
  };
  
  export const saveEmailAgents = (agents) => {
    return {
      type: SAVE_EMAIL_AGENTS,
      payload: agents,
    };
  };
  export const getEmailGroups = () => {
    return {
      type: GET_EMAIL_GROUPS,
    };
  };
  
  export const saveEmailGroups = (groups) => {
    return {
      type: SAVE_EMAIL_GROUPS,
      payload: groups,
    };
  };
  export const saveEmailAssignmentRules = (rules) => {
    return {
      type: SAVE_EMAIL_ASSIGNMENT_RULES,
      payload: rules,
    };
  };
  export const sendEmailAssignmentRules = (rules) => {
    return {
      type: SEND_EMAIL_ASSIGNMENT_RULES,
      payload: rules,
    };
  };
  export const updateEmailAssignmentRules = ({ id, rules }) => {
    return {
      type: UPDATE_EMAIL_ASSIGNMENT_RULES,
      payload: { id, rules },
    };
  };
  export const updateEmailAssignmentRuleStatus = ({ id, rules }) => {
    return {
      type: UPDATE_EMAIL_ASSIGNMENT_RULE_STATUS,
      payload: { id, rules },
    };
  };
  export const getAllEmailAssignmentRules = () => {
    return {
      type: GET_ALL_EMAIL_ASSIGNMENT_RULES,
    };
  };
  export const saveAllEmailAssignmentRules = (allRules) => {
    return {
      type: SAVE_ALL_EMAIL_ASSIGNMENT_RULES,
      payload: allRules,
    };
  };
  
  export const deleteEmailAssignmentRule = (ruleId) => {
    return {
      type: DELETE_EMAIL_ASSIGNMENT_RULE,
      payload: ruleId,
    };
  };
  